import getBasePath from '../functions/api-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'v1');

const clienteActions = {
    buscar: { method: 'GET', url: `${basePath}/articulos?with=iva,ieps,moneda&filtros={filtros}` },
    buscarById: { method: 'GET', url: `${basePath}/articulos/{idArticulo}?with=iva,ieps,moneda` },
    getDetalles: { method: 'GET', url: `${basePath}/articulos/detallesstshop/{idArticulo}?` },
    buscarSecundaria: { method: 'GET', url: `${basePath}/articulos/{idArticulo}/secundarias?` },
    getBanners: { method: 'GET', url: `${basePath}/articulos/banners?` },

};

export default resource => resource(`${basePath}`, {}, clienteActions);


// WEBPACK FOOTER //
// ./src/common/resources/articulo.js